const API_DISPLAY_KEY_PATTERN = /^api_(?:choice|option)_\d+$/;

export function normalizeCustomerDisplayName(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmed = value.trim();
  if (!trimmed || API_DISPLAY_KEY_PATTERN.test(trimmed)) {
    return undefined;
  }

  return trimmed;
}

export function resolveCustomerDisplayName(...candidates: unknown[]): string | undefined {
  for (const candidate of candidates) {
    const displayName = normalizeCustomerDisplayName(candidate);
    if (displayName) {
      return displayName;
    }
  }

  return undefined;
}
